module.exports = __webpack_public_path__ + "static/media/iphone_trd.97118bcf.svg";